/* tslint:disable */
/* eslint-disable */
/**
 * UserSearchDataProject
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { SearchLogRequest } from '../model';
/**
 * SearchLogAPIApiApiSearchLogAddlogPost - axios parameter creator
 * 
 * @param {SearchLogRequest} [searchLogRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SearchLogAPIApiApiSearchLogAddlogPostAxiosParamCreator (searchLogRequest?: SearchLogRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/SearchLog/Addlog`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(searchLogRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SearchLogAPIApiApiSearchLogGetLogsGet - axios parameter creator
 * 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SearchLogAPIApiApiSearchLogGetLogsGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/SearchLog/GetLogs`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * SearchLogAPIApiApiSearchLogIdGet - axios parameter creator
 * 
 * @param {string} id 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function SearchLogAPIApiApiSearchLogIdGetAxiosParamCreator (id: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('apiSearchLogIdGet', 'id', id)
    const localVarPath = `/api/SearchLog/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiSearchLogAddlogPost operation in SearchLogAPIApi.
 * @export
 * @interface SearchLogAPIApiApiSearchLogAddlogPostRequest
 */
export interface SearchLogAPIApiApiSearchLogAddlogPostRequest {
    /**
     * 
     * @type {SearchLogRequest}
     * @memberof SearchLogAPIApiApiSearchLogAddlogPost
     */
    readonly searchLogRequest?: SearchLogRequest
}

/**
 * Request parameters for apiSearchLogIdGet operation in SearchLogAPIApi.
 * @export
 * @interface SearchLogAPIApiApiSearchLogIdGetRequest
 */
export interface SearchLogAPIApiApiSearchLogIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof SearchLogAPIApiApiSearchLogIdGet
     */
    readonly id: string
}

/**
* 
* @param {SearchLogAPIApiApiSearchLogAddlogPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SearchLogAPIApiApiSearchLogAddlogPost(requestParameters: SearchLogAPIApiApiSearchLogAddlogPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SearchLogAPIApiApiSearchLogAddlogPostAxiosParamCreator(requestParameters.searchLogRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SearchLogAPIApiApiSearchLogGetLogsGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SearchLogAPIApiApiSearchLogGetLogsGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<Array<SearchLogRequest>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {SearchLogAPIApiApiSearchLogIdGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function SearchLogAPIApiApiSearchLogIdGet(requestParameters: SearchLogAPIApiApiSearchLogIdGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await SearchLogAPIApiApiSearchLogIdGetAxiosParamCreator(requestParameters.id, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
